export const convertTime = (time) => {
    return new Date(time).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
    });
};
